"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PrepaInAds {
    constructor() {
        this.storageKey = 'prepain_ads_closed';
        this.adsUrl = window.location.origin + '/wp-content/themes/prepain/assets/img/ads/';
        this.adsHorizontalAssets = [
            'horizontal/prepain_horizontal_1',
            'horizontal/prepain_horizontal_2',
            'horizontal/prepain_horizontal_3',
            'horizontal/prepain_horizontal_4'
        ];
        this.adsVerticalAssets = [
            'vertical/prepain_vertical_1',
            'vertical/prepain_vertical_2',
            'vertical/prepain_vertical_3',
            'vertical/prepain_vertical_4'
        ];
        this.lightbox = document.getElementById('ads-lightbox');
        this.closeButton = this.lightbox ? this.lightbox.querySelector('button') : null;
        this.adsHorizontalContainer = document.querySelector('.prepain-ad-horizontal');
        this.adsVerticalContainer = document.querySelector('.prepain-ad-vertical');
        // append a random asset to both horizontal and vertical container
        this.appendRandomAsset();
    }
    appendRandomAsset() {
        var _a, _b, _c, _d, _e, _f;
        const choosenHorizontalAsset = this.adsHorizontalAssets[Math.floor(Math.random() * this.adsHorizontalAssets.length)];
        const choosenVerticalAsset = this.adsVerticalAssets[Math.floor(Math.random() * this.adsVerticalAssets.length)];
        (_a = this.adsHorizontalContainer) === null || _a === void 0 ? void 0 : _a.appendChild(this.createImageElement(choosenHorizontalAsset));
        (_b = this.adsVerticalContainer) === null || _b === void 0 ? void 0 : _b.appendChild(this.createImageElement(choosenVerticalAsset));
        // add utm_content to the existing link
        (_c = this.adsHorizontalContainer) === null || _c === void 0 ? void 0 : _c.setAttribute('href', ((_d = this.adsHorizontalContainer) === null || _d === void 0 ? void 0 : _d.getAttribute('href')) + '&utm_content=' + encodeURIComponent(choosenHorizontalAsset));
        (_e = this.adsVerticalContainer) === null || _e === void 0 ? void 0 : _e.setAttribute('href', ((_f = this.adsVerticalContainer) === null || _f === void 0 ? void 0 : _f.getAttribute('href')) + '&utm_content=' + encodeURIComponent(choosenVerticalAsset));
    }
    createImageElement(assetName) {
        const img = document.createElement('img');
        img.src = this.adsUrl + assetName + '.png';
        img.className = 'w-full h-auto';
        img.alt = assetName;
        return img;
    }
    init() {
        if (!this.lightbox)
            return;
        // Always show the lightbox when the page loads
        this.showLightbox();
        this.setupEventListeners();
    }
    showLightbox() {
        if (this.lightbox) {
            // Make sure the lightbox is visible
            this.lightbox.classList.remove('hidden');
            // Prevent scrolling on the body when lightbox is open
            document.body.style.overflow = 'hidden';
        }
    }
    hideLightbox() {
        if (this.lightbox) {
            this.lightbox.classList.add('hidden');
            // Restore scrolling
            document.body.style.overflow = '';
            // No longer storing closed ads in localStorage
        }
    }
    setupEventListeners() {
        // Add click event to close button
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.hideLightbox());
        }
        // Close lightbox when clicking outside the content area
        if (this.lightbox) {
            this.lightbox.addEventListener('click', (e) => {
                if (e.target === this.lightbox) {
                    this.hideLightbox();
                }
            });
        }
        // Close with escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.hideLightbox();
            }
        });
    }
    getCurrentAdImageId() {
        var _a;
        // Get the current ad image ID from the img element
        const adImage = (_a = this.lightbox) === null || _a === void 0 ? void 0 : _a.querySelector('img');
        return (adImage === null || adImage === void 0 ? void 0 : adImage.src) || 'default';
    }
    getClosedAdsFromStorage() {
        const stored = localStorage.getItem(this.storageKey);
        return stored ? JSON.parse(stored) : [];
    }
    saveClosedAdToStorage(adId) {
        const adsClosed = this.getClosedAdsFromStorage();
        if (!adsClosed.includes(adId)) {
            adsClosed.push(adId);
            localStorage.setItem(this.storageKey, JSON.stringify(adsClosed));
        }
    }
}
exports.default = PrepaInAds;
